module.exports = __webpack_public_path__ + "static/assets/fb38b64b9390074cd44eed1569a6bfed.png";